import { IManifestContextBuilder } from '@wix/editor-platform-manifest-services';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { CompRef } from '@wix/document-services-types';
import { EditorPointer } from '@wix/editorx-core-api';

import actions from './actions';

export const buildGlobalDesignContext = (
  editorPointer: EditorPointer<CompRef>,
  actionName: StylesDerivedNativeActionNames,
): IManifestContextBuilder => {
  return (builder) => {
    builder.byEditorPointer(editorPointer, (manifest) => {
      if (!manifest) {
        return;
      }

      const action = actions[actionName];
      return action.manifestProcessor(
        { editorElement: manifest },
        actionName,
        builder,
        editorPointer,
      );
    });
  };
};
